<template>
	<b-button
		v-if="!disabled"
		:variant="variant"
		:to="to"
		class="border-0 button-with-tooltip"
		:disabled="false"
		@click="onClick"
		v-b-tooltip.hover="{
			title: textTooltip,
			customClass: 'custom-tooltip',
			interactive: false,
			placement: 'bottom'
		}"
	>
		<slot name="content">
			<b-icon :icon="icon" :font-scale="scale" />
		</slot>
	</b-button>

	<b-button v-else :variant="variant" :to="to" class="border-0 button-with-tooltip" :disabled="true" @click="onClick">
		<slot name="content">
			<b-icon :icon="icon" :font-scale="scale" />
		</slot>
	</b-button>
</template>

<script>
export default {
	props: {
		icon: {
			type: String,
			required: true
		},
		variant: {
			type: String,
			default: "outline-dark"
		},
		to: {
			type: [String, Object],
			default: ""
		},
		disabled: {
			type: Boolean,
			default: false
		},
		scale: {
			type: String,
			default: "1.0"
		},
		textTooltip: {
			type: String,
			default: ""
		}
	},
	methods: {
		onClick() {
			this.$emit("click");
		}
	}
};
</script>
